import React, { useState } from 'react';

import { useIntl } from 'react-intl';

import Modal, { ModalContent, ModalHeading, ModalSize } from 'components/modal';
import { useFeatureDisclaimers } from 'hooks/use-feature-disclaimers';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

import { ItemNutrition } from './item-nutrition';
import { NutritionDisclaimer } from './styled';
import { INutritionProps } from './types';

const Nutrition: React.FC<INutritionProps> = ({ nutritionFacts, activatingElement }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { formatMessage } = useIntl();
  const { featureDisclaimers } = useFeatureDisclaimers();
  const { calorie } = featureDisclaimers || {};

  const enableFeatureNutritionIntegration = useFlag(
    LaunchDarklyFlag.ENABLE_FEATURE_NUTRITION_INTEGRATION
  );
  const enableStaticMenuAllergens = useFlag(LaunchDarklyFlag.ENABLE_STATIC_MENU_ALLERGENS);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const modalHeading = formatMessage({ id: 'nutritionalInformation' });

  return (
    <>
      {React.cloneElement(activatingElement, { onClick: openModal })}
      {isModalOpen && (
        <Modal
          size={ModalSize.SMALL}
          onDismiss={closeModal}
          mParticleEventData={{
            modalAppearanceEventMessage: 'Nutritional Information',
          }}
          data-testid="nutrition-modal"
        >
          <ModalContent>
            <ModalHeading>{modalHeading}</ModalHeading>
            {nutritionFacts
              .filter(
                elem =>
                  elem.itemName.toLowerCase() !== 'combo item' &&
                  elem.itemName.toLowerCase() !== 'mix n match'
              )
              .map(({ itemName, itemImage, facts, allergenGroups, additionalItemInformation }) => (
                <ItemNutrition
                  key={itemName}
                  allergenGroups={allergenGroups}
                  itemImage={itemImage}
                  itemName={itemName}
                  nutritionInfo={facts}
                  enableFeatureNutritionIntegration={enableFeatureNutritionIntegration}
                  enableStaticMenuAllergens={enableStaticMenuAllergens}
                  additionalItemInformation={additionalItemInformation}
                />
              ))}
            <NutritionDisclaimer content={calorie?.localeRaw} />
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default Nutrition;
